import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { OnboardingHeader } from '../../../components/onboarding-header'

function AngularOnboardingHeader(props) {
  return (
    <OnboardingHeader
      organizationID={props.organizationID}
      applicationID={props.applicationID}
      breakdown={props.breakdown}
    />
  )
}

// Update sliding tutorial yOffset value when onboarding header updates his size and visibility

export const reactOnboardingHeader = createNgReactBridgeDirective(
  'reactOnboardingHeader',
  [],
  AngularOnboardingHeader,
  ['breakdown', 'organizationID', 'applicationID']
)
